export enum LoadingStatus {
  Idle = 'idle',
  Loading = 'loading',
  Failed = 'failed',
}
